import {isAnyOf} from '@reduxjs/toolkit'

import {getSettlementDetail, getSettlementHistory} from '@web/actions/saleSettlement'
import {APIStatus, PageSet} from '@web/core/constants'
import makeSlice from '@web/slices/common/sliceMaker'

import {initSaleSettlementDetail} from '../../actions/saleSettlementDetail'

const commonSlice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(getSettlementDetail.pending, (state) => {
                state.pageSet = PageSet.SALE_SETTLEMENT_DETAIL
            })
            .addCase(getSettlementDetail.fulfilled, (state, {payload}) => {
                state.seqID = payload.orderNo
            })
            .addCase(getSettlementHistory.pending, (state) => {
                state.pageSet = PageSet.SALE_SETTLEMENT
            })
            .addMatcher(isAnyOf(getSettlementHistory.pending, initSaleSettlementDetail.pending), (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isAnyOf(getSettlementHistory.fulfilled, initSaleSettlementDetail.fulfilled), (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addMatcher(isAnyOf(getSettlementHistory.rejected, initSaleSettlementDetail.rejected), (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default commonSlice.reducer
